import React from "react";
import DataTable from "react-data-table-component";
import moment from "moment";
import CurrencyInput from "react-currency-input-field";
import Moment from "moment";
import Select from "react-select";
import ReactPaginate from "react-paginate";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  TabContent,
  TabPane,
  Container,
  Collapse,
  Row,
  Col,
  Tab,
  Modal,
  ModalBody,
  Table,
  OverlayTrigger,
  Tooltip,
  Image,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAllListUsaha } from "stores";
import GoogleMapReact from "google-map-react";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

function ListUsaha() {
  const dispatch = useDispatch();
  const usahaReducer = useSelector((state) => state.usahaReducer);
  // console.log(usahaReducer, "USAHA");
  const [searchText, setSearchText] = React.useState("");
  const [listAllUsaha, setListAllUsaha] = React.useState([]);
  const [modalAlamatVisible, setModalAlamatVisible] = React.useState(false);
  const [selectedAlamat, setSelectedAlamat] = React.useState(null);
  const [selectedNamaUsaha, setSelectedNamaUsaha] = React.useState(null);
  const [modalPreviewFoto, setModalPreviewFoto] = React.useState(false);
  const [modalNamaUsahaVisible, setModalNamaUsahaVisible] =
    React.useState(false);
  const [mapLocation, setMapLocation] = React.useState({
    lat: null,
    lng: null,
  });
  const [showModal, setShowModal] = React.useState(false);
  const [showModalFoto, setShowModalFoto] = React.useState(false);
  const [currentPhotos, setCurrentPhotos] = React.useState([]);

  const [page, setPage] = React.useState(0);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [pending, setPending] = React.useState(false);
  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };

  const handleFotoClick = (fotoArray) => {
    setCurrentPhotos(fotoArray); // Set foto untuk modal
    setShowModalFoto(true); // Tampilkan modal
  };

  const closeModalFoto = () => {
    setShowModalFoto(false); // Sembunyikan modal
    setCurrentPhotos([]); // Reset foto
  };

  const handleAlamatClick = (Alamat) => {
    setSelectedAlamat(Alamat);
    setModalAlamatVisible(true);
  };

  const handleNamaUsahaClick = (NamaUsaha) => {
    setSelectedNamaUsaha(NamaUsaha);
    setModalNamaUsahaVisible(true);
  };

  const handleLokasiClick = (latitude, longitude) => {
    setMapLocation({ lat: latitude, lng: longitude });
    setShowModal(true);
  };

  const handleFilterChange = () => {
    setPending(true);
    setPage(0);
    getAllListUsaha(dispatch, {
      cari: searchText,
      page: page + 1,
      limit: totalPerHalaman,
    })
      .then((response) => {
        setPending(false);
      })
      .catch((error) => {
        setPending(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilterChange();
    }
  };

  const defaultProps = {
    center: { lat: -6.2, lng: 106.8 }, // Default location (Jakarta)
    zoom: 11,
  };

  const AnyReactComponent = ({ text }) => (
    <div style={{ color: "red", fontWeight: "bold" }}>
      <i className="fas fa-map-marker-alt" style={{ fontSize: 25 }}></i> {text}
    </div>
  );
  const closeModal = () => setShowModal(false);

  const AlamatUsahaModal = () => (
    <Modal
      show={modalAlamatVisible}
      onHide={() => setModalAlamatVisible(false)}
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Title
        style={{ textAlign: "center", fontWeight: "bolder", margin: 0 }}
      >
        Alamat Usaha Lengkap
        <hr></hr>
      </Modal.Title>
      {/* <Modal.Body>{selectedKeterangan}</Modal.Body> */}
      <Card.Body>{selectedAlamat}</Card.Body>
    </Modal>
  );

  const NamaUsahaModal = () => (
    <Modal
      show={modalNamaUsahaVisible}
      onHide={() => setModalNamaUsahaVisible(false)}
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Title
        style={{ textAlign: "center", fontWeight: "bolder", margin: 0 }}
      >
        Nama Usaha Lengkap
        <hr></hr>
      </Modal.Title>
      {/* <Modal.Body>{selectedKeterangan}</Modal.Body> */}
      <Card.Body>{selectedNamaUsaha}</Card.Body>
    </Modal>
  );

  React.useEffect(() => {
    let tmp =
      usahaReducer.listUsaha.data &&
      usahaReducer.listUsaha.data.map((val) => {
        return {
          ...val,
          action: <></>,
        };
      });
    setListAllUsaha(tmp);
  }, [usahaReducer]);

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const customStyles = {
    rows: {
      style: {
        height: "70px", // override the row height
      },
    },
    headRow: {
      style: {
        minHeight: 35,
        backgroundColor: "#F8F8F8",
        // fontFamily: "Poppins",
        justifyContent: "center",
      },
    },
    headCells: {
      style: {
        minHeight: 50,
        fontWeight: "bold",
        fontSize: 14,
        "&:first-child": {
          borderRight: "1px solid #ccc",
        },
      },
    },
    cells: {
      style: {
        minHeight: "70px",
        whiteSpace: "normal",
        wordBreak: "break-word",
        "&:first-child": {
          borderRight: "1px solid #ccc",
        },
      },
    },
  };

  const colUsaha = [
    {
      name: "No",
      width: "100px",
      center: true,
      selector: (row, index) => index + usahaReducer.listUsaha.pagingCounter,
    },
    {
      name: "ID Usaha",
      minWidth: "200px",
      center: true,
      selector: (row) => row.idUsaha,
    },
    {
      name: "Nama Usaha",
      minWidth: "300px",
      center: true,
      selector: (row) => row.namaUsaha,
      wrap: true,
    },
    {
      name: "Pemilik Usaha",
      minWidth: "300px",
      center: true,
      selector: (row) => (!row.pemilikUsaha ? "-" : row.pemilikUsaha.nama),
    },
    {
      name: "Alamat Usaha",
      minWidth: "300px",
      center: true,
      selector: (row) => (row.alamatUsaha === "" ? "-" : row.alamatUsaha),
      wrap: true,
    },
    {
      name: "Lokasi",
      minWidth: "200px",
      center: true,
      cell: (row) => {
        const [longitude, latitude] = row.location.coordinates;
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#007BFF", // Blue color for action indication
              cursor: "pointer",
              fontWeight: "bold",
              textDecoration: "underline", // Add underline to make it look like a link
            }}
            onClick={() => handleLokasiClick(latitude, longitude)}
            title={`Lihat lokasi di peta: Lat ${latitude}, Long ${longitude}`} // Tooltip for additional info
          >
            <i
              class="fas fa-map-pin"
              style={{
                marginRight: "8px",
                fontSize: "18px",
              }}
            ></i>
            <span>Lihat Lokasi</span>
          </div>
        );
      },
    },
    {
      name: "Rating",
      minWidth: "200px",
      center: true,
      selector: (row) => row.rating,
      cell: (row) => {
        const rating = row.rating;
        const fullStars = Math.floor(rating);
        const halfStar = rating % 1 >= 0.5;
        const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {Array(fullStars)
              .fill(0)
              .map((_, index) => (
                <FaStar key={`full-${index}`} style={{ color: "gold" }} />
              ))}
            {halfStar && <FaStarHalfAlt style={{ color: "gold" }} />}
            {Array(emptyStars)
              .fill(0)
              .map((_, index) => (
                <FaRegStar
                  key={`empty-${index}`}
                  style={{ color: "lightgray" }}
                />
              ))}
          </div>
        );
      },
    },
    {
      name: "Foto Usaha",
      minWidth: "300px",
      center: true,
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#E5594C", // Blue color for action indication
            cursor: "pointer",
            fontWeight: "bold",
            // textDecoration: "underline", // Add underline to make it look like a link
          }}
          onClick={() => handleFotoClick(row.fotoUsaha)}
        >
          <i
            class="far fa-images"
            style={{
              marginRight: "8px",
              fontSize: "18px",
            }}
          ></i>
          <span>Lihat Foto</span>
        </div>
      ),
    },
    {
      name: "Omset Perbulan",
      minWidth: "300px",
      center: true,
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.omsetPerBulan);
        return formattedValue;
      },
    },
    {
      name: "Pengeluaran Perbulan",
      minWidth: "300px",
      center: true,
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.pengeluaranPerBulan);
        return formattedValue;
      },
    },
    {
      name: "Keuntungan Perbulan",
      minWidth: "300px",
      center: true,
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.keuntunganPerBulan);
        return formattedValue;
      },
    },
    {
      name: "No Telepon Usaha",
      minWidth: "200px",
      center: true,
      selector: (row) => (row.noTelpUsaha === "" ? "-" : row.noTelpUsaha),
    },
    {
      name: "Mulai Usaha",
      minWidth: "200px",
      center: true,
      selector: (row) => (row.mulaiUsaha === "" ? "-" : row.mulaiUsaha),
    },
    {
      name: "Jenis Usaha",
      minWidth: "250px",
      center: true,
      selector: (row) => (row.jenisUsaha === "" ? "-" : row.jenisUsaha),
    },
    {
      name: "Kecamatan",
      minWidth: "250px",
      center: true,
      selector: (row) => (row.kecamatan === "" ? "-" : row.kecamatan),
    },
    {
      name: "Kabupaten",
      minWidth: "250px",
      center: true,
      selector: (row) => (row.kabupaten === "" ? "-" : row.kabupaten),
    },
    {
      name: "Provinsi",
      minWidth: "250px",
      center: true,
      selector: (row) => (row.provinsi === "" ? "-" : row.provinsi),
    },
  ];

  React.useEffect(() => {
    setPending(true);
    getAllListUsaha(dispatch, {
      cari: searchText,
      page: page + 1,
      limit: totalPerHalaman,
    })
      .then((response) => {
        // setLoading(false);
        setPending(false);
      })
      .catch((error) => {
        // setLoading(false);
        setPending(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [page, totalPerHalaman]);
  return (
    <>
      <div
        id="previewImage"
        style={{
          display: modalPreviewFoto ? "block" : "none",
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: "9999",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={modalPreviewFoto}
          alt="Preview"
          style={{
            borderRadius: "5px",
            boxShadow: "4px 4px 8px 0px rgba(0,0,0,0.75)",
            maxHeight: "80%",
            maxWidth: "80%",
            objectFit: "contain",
            background: "transparent",
            position: "absolute",
            top: "50%", // Posisi vertikal ke tengah
            left: "50%", // Posisi horizontal ke tengah
            transform: "translate(-50%, -50%)",
          }}
        />
        <button
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            fontSize: "20px",
            cursor: "pointer",
          }}
          onClick={() => setModalPreviewFoto("")}
        >
          &times;
        </button>
      </div>

      <Modal show={showModalFoto} onHide={closeModalFoto} size="lg" centered>
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <Card className="stacked-form" style={{ border: 0 }}>
            <Card.Header>
              <Card.Title
                as="h4"
                style={{
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textAlign: "center",
                }}
              >
                Foto Usaha
                <hr></hr>
              </Card.Title>
            </Card.Header>
            <Card.Body>
              {currentPhotos.length > 0 ? (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    overflowX: "auto",
                    gap: "10px",
                    justifyContent: "center",
                  }}
                >
                  {currentPhotos.map((photo, index) => (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Detail Gambar</Tooltip>}
                    >
                      <Image
                        key={index}
                        src={photo.url}
                        style={{
                          width: 300,
                          height: 350,
                          margin: 20,
                          cursor: "pointer",
                          objectFit: "contain",
                        }}
                        thumbnail
                        onClick={() => {
                          setModalPreviewFoto(photo.url);
                        }}
                      />
                    </OverlayTrigger>
                    // <img
                    //   key={index}
                    //   src={photo.url} // Ambil key `url`
                    //   alt={`Foto Usaha ${index + 1}`}
                    //   style={{
                    //     maxWidth: "500px",
                    //     maxHeight: "600px",
                    //     objectFit: "cover",
                    //     borderRadius: "8px",
                    //     flexShrink: 0,
                    //   }}
                    // />
                  ))}
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginBottom: "1rem",
                      color: "red",
                    }}
                  >
                    Maaf, belum ada foto usaha saat ini.
                  </p>
                  <img
                    src={require("assets/img/sorry.jpg").default}
                    alt="Sorry"
                    style={{
                      maxWidth: "20%",
                      display: "block",
                      margin: "0 auto",
                    }}
                  />
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Modal>

      <Modal
        show={showModal}
        onHide={closeModal}
        size="lg"
        centered
        keyboard={false}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontWeight: "bolder" }}>
            Lokasi Usaha
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ height: "400px", width: "100%" }}>
            <GoogleMapReact
              bootstrapURLKeys={{
                key: "AIzaSyAXcaz5mPbGbZs4rrFVHLTANG0NLoBEp2I",
              }}
              center={{
                lat: mapLocation.lat || defaultProps.center.lat,
                lng: mapLocation.lng || defaultProps.center.lng,
              }}
              defaultZoom={defaultProps.zoom}
            >
              {mapLocation.lat !== null && mapLocation.lng !== null && (
                <AnyReactComponent
                  lat={mapLocation.lat}
                  lng={mapLocation.lng}
                  // text="Marker"
                />
              )}
            </GoogleMapReact>
          </div>
        </Modal.Body>
      </Modal>

      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title
                  as="h3"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                  }}
                >
                  list usaha
                </Card.Title>
                <Row>
                  <Col md={5} style={{ marginTop: 45 }}>
                    <div>
                      <InputGroup>
                        <Form.Control
                          style={{
                            paddingLeft: "10px",
                          }}
                          type="text"
                          value={searchText}
                          onChange={handleSearch}
                          onKeyDown={handleKeyDown}
                          placeholder="Nama Usaha/Provinsi/Kabupaten/Kota/Id Usaha"
                        />
                        <InputGroup.Append>
                          <InputGroup.Text
                            style={{ cursor: "pointer" }}
                            onClick={handleClearSearch}
                          >
                            <i class="fas fa-times"></i>
                          </InputGroup.Text>
                        </InputGroup.Append>
                      </InputGroup>
                    </div>
                  </Col>
                  <Col style={{ marginTop: 45 }}>
                    <Button
                      // variant="info"
                      style={{
                        fontSize: 16,
                        backgroundColor: "#00BFFF",
                        border: 0,
                        paddingTop: 10,
                        paddingBottom: 7,
                      }}
                      onClick={handleFilterChange}
                    >
                      <i class="fas fa-search"></i>
                    </Button>
                  </Col>
                </Row>
                <Tab.Content>
                  {" "}
                  <Card.Body>
                    <div>
                      <div>
                        <DataTable
                          columns={colUsaha}
                          data={listAllUsaha}
                          customStyles={customStyles}
                          paginationPerPage={totalPerHalaman}
                          progressPending={pending}
                        />
                      </div>
                      <div style={{ marginTop: 35 }}>
                        <Row
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Col>
                            <Row style={{ alignItems: "center" }}>
                              <div
                                style={{
                                  paddingRight: 0,
                                  marginLeft: 20,
                                  marginRight: 10,
                                }}
                              >
                                <label style={{ fontWeight: "bold" }}>
                                  Rows per page
                                </label>
                              </div>
                              <Col sm="3" style={{ paddingLeft: 0 }}>
                                <Select
                                  className="react-select primary"
                                  classNamePrefix="react-select"
                                  name="Pilih Client"
                                  value={options.find(
                                    (option) => option.value === totalPerHalaman
                                  )}
                                  onChange={handlePageSizeChange}
                                  options={options}
                                  placeholder="Rows per page"
                                />
                              </Col>
                            </Row>
                          </Col>

                          <Col>
                            <ReactPaginate
                              forcePage={page}
                              containerClassName="paginations justify-content-end"
                              previousClassName="pages-items-containerrs"
                              previousLinkClassName="pages-links-labells"
                              nextClassName="pages-items-containerrs"
                              nextLinkClassName="pages-links-labells"
                              breakClassName="pages-items-containerrs"
                              pageCount={usahaReducer.listUsaha.totalPages}
                              pageRangeDisplayed={3}
                              marginPagesDisplayed={1}
                              pageLinkClassName="pages-links-labells"
                              pageClassName="pages-items-containerrs"
                              activeClassName="activees"
                              activeLinkClassName="activess"
                              nextLabel=" > "
                              previousLabel=" < "
                              initialPage={page}
                              disableInitialCallback={true}
                              onPageChange={(val) => {
                                setPage(val.selected);
                              }}
                            />
                          </Col>
                        </Row>
                      </div>
                      {modalAlamatVisible && <AlamatUsahaModal />}
                      {modalNamaUsahaVisible && <NamaUsahaModal />}
                    </div>
                  </Card.Body>
                </Tab.Content>
              </Card.Header>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListUsaha;
